export type VariantType = 'system' | 'success' | 'error' | 'warning';

import { IToast } from '.';
import i18n from '../../i18n';

export const createToast = async (toast: IToast) => {
  const toastElement = document.createElement('bds-toast') as unknown as HTMLElement & { create: (config: unknown) => Promise<void> };
  document.body.appendChild(toastElement as Node);
  let toastText = i18n.t('go-personal-toast-success');
  let variant: VariantType = 'success';
  let icon = 'like';

  if (toast == 'failed') {
    toastText = i18n.t('go-personal-toast-error');
    variant = 'error';
    icon = 'error';
  }

  const actionType = 'icon';
  const position = 'bottom-left';
  const buttonAction = 'close';
  const toastTitle = '';
  const duration = 8; // seconds
  await toastElement.create({
    actionType,
    toastTitle,
    buttonAction,
    variant,
    icon,
    toastText,
    position,
    duration,
  });
};
